export const deepDiveObject = (key: string, theObject: any) => {
  var result = null
  if (theObject instanceof Array) {
    for (var i = 0; i < theObject.length; i++) {
      result = deepDiveObject(key, theObject[i])
      if (result) {
        break
      }
    }
  } else {
    for (var prop in theObject) {
      if (prop === key) {
        result = theObject[prop]
        break
      }
      if (
        theObject[prop] instanceof Object ||
        theObject[prop] instanceof Array
      ) {
        result = deepDiveObject(key, theObject[prop])
        if (result) {
          break
        }
      }
    }
  }
  return result
}

interface IExtractionInfo {
  key: string
  firstIndex?: boolean
}
export const extractGqlResult = (
  extractionInfo: IExtractionInfo,
  data: any
) => {
  let d = deepDiveObject(extractionInfo?.key, data)
  if (extractionInfo?.firstIndex) {
    if (Array.isArray(d?.nodes) && d?.nodes?.length > 0) {
      return d?.nodes[0]
    }
    return d
  }

  return d?.nodes
}
